import React from "react";
import {
  TextInput,
  SimpleForm,
  required,
  ReferenceInput,
  AutocompleteInput,
  NumberInput,
  EditProps,
} from "react-admin";
import { GetParam } from "utils/tools";
import { Grid, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import CustomEditToolbar from "components/CustomEditToolbar";
import EditWrapper from "../../components/EditWrapper";

const AreasEdit = (props: EditProps) => {
  const param = GetParam();

  const { id } = props;

  const breadcrumb = [
    { title: "Schools", link: `/schools` },
    { title: "Areas", link: `/schools/${param.get("schoolId")}/show/3` },
    { title: id, link: `` },
  ];

  return (
    <>
      <EditWrapper
        breadcrumb={breadcrumb}
        customName={{
          resourceName: "CCA School Area",
          propertyName: "name",
        }}
        {...props}
      >
        <SimpleForm
          toolbar={
            <CustomEditToolbar
              redirectLink={`/schools/${param.get("schoolId")}/show/3`}
            />
          }
        >
          <SanitizedGrid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6">School</Typography>
            </Grid>
            <Grid item xs={4}>
              <ReferenceInput
                label="Select School"
                source="schoolId"
                reference="schools"
                disabled
              >
                <AutocompleteInput optionText="name" />
              </ReferenceInput>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h6">Details</Typography>
            </Grid>
            <Grid item xs={4}>
              <TextInput source="name" validate={required()} />
            </Grid>
            <Grid item xs={4}>
              <NumberInput source="maxDistanceInMeters" />
            </Grid>
          </SanitizedGrid>
        </SimpleForm>
      </EditWrapper>
    </>
  );
};

export default AreasEdit;
